export default __webpack_public_path__ + "static/media/progress1.f89e0458.svg";